import { render, staticRenderFns } from "./_base-number-input-ranger.vue?vue&type=template&id=23c1fb1d&scoped=true&"
import script from "./_base-number-input-ranger.vue?vue&type=script&lang=js&"
export * from "./_base-number-input-ranger.vue?vue&type=script&lang=js&"
import style0 from "./_base-number-input-ranger.vue?vue&type=style&index=0&id=23c1fb1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1fb1d",
  null
  
)

export default component.exports